import { FC } from 'react';
import { InView } from 'react-intersection-observer';

import { PromoRollSynthJobFieldsFragment } from '@entities/PromoRollSynthJob/model';

import PromoRollSynthJobItem from '../PromoRollSynthJobItem/PromoRollSynthJobItem';
import styles from './PromoRollSynthJobList.module.scss';

type Props = {
  jobs: PromoRollSynthJobFieldsFragment[];
  selectedIds: Set<string>;
  highlightedJobId?: string | null;
  hasNextPage: boolean;
  onEndReached: () => void;
  onSelect: (id: string, selected: boolean) => void;
  onDelete: (id: string) => void;
  onRetry: (job: PromoRollSynthJobFieldsFragment) => void;
};

const PromoRollSynthJobList: FC<Props> = ({
  jobs,
  selectedIds,
  highlightedJobId,
  hasNextPage,
  onEndReached,
  onSelect,
  onDelete,
  onRetry,
}) => {
  if (jobs.length === 0) return null;

  return (
    <div className={styles.list}>
      {jobs.map((job) => (
        <PromoRollSynthJobItem
          key={job.id}
          job={job}
          isSelected={selectedIds.has(job.id)}
          isHighlighted={job.id === highlightedJobId}
          onSelect={onSelect}
          onDelete={onDelete}
          onRetry={onRetry}
        />
      ))}
      {hasNextPage && (
        <div className={styles.sentinel}>
          <InView onChange={(inView) => inView && onEndReached()} />
        </div>
      )}
    </div>
  );
};

export default PromoRollSynthJobList;
